<template>
  <div>
    <div v-if="Busy == true">
      <CCol sm="12" md="12">
        <div class="app flex-row align-items-center">
          <div class="container d-flex justify-content-center">
            <PulseLoader float />
          </div>
        </div>
      </CCol>
    </div>
    <div v-else>
      <CCard class="p-3">
        <CCol sm="12">
          <CRow>
            <CCol sm="8"
              ><h6>Add New Schedule</h6>
              <label class="small text-muted"
                >To add new schedule for your Tuition Center</label
              ></CCol
            >
            <CCol sm="4">
              <div style="float: right">
                <CButton
                  type="button"
                  class="btn btn-success"
                  @click="CreateSchedule(subjectsSchedule.ID)"
                >
                  Save Schedule</CButton
                >
              </div></CCol
            >
          </CRow>
        </CCol>
        <div style="clear: both"></div>
        <hr />
        <h5>{{ subjectsSchedule.SubjectName }}</h5>
        Grade: {{ subjectsSchedule.Grade }} <br />
        Class Name: {{ subjectsSchedule.ClassName }}
        <hr />
        <CRow>
          <CCol sm="4">
            Start Date
            <CInput type="date" v-model="StartDate" />
          </CCol>
          <CCol sm="4">
            End Date
            <CInput type="date" v-model="EndDate" />
          </CCol>
          <CCol sm="4">
            Day
            <v-select
              v-model="selectedDay"
              :options="options"
              placeholder="--Please Select Day--"
              class="custom-dropdown"
              label="dayName"
            ></v-select>
          </CCol>
          <CCol sm="4">
            Start Time
            <CInput type="datetime-local" v-model="ScheduleTime" />
          </CCol>
          <CCol sm="4">
            End Time
            <CInput type="datetime-local" v-model="ScheduleTimeEnd" />
          </CCol>
          <CCol sm="4"> </CCol>
        </CRow>
      </CCard>

      <CCard class="p-3">
        <CCol sm="12">
          <CRow>
            <CCol sm="8"
              ><h6>Update & Delete Schedule</h6>
              <label class="small text-muted"
                >To update or delete schedule for your Tuition Center</label
              ></CCol
            >
            <CCol sm="4"> </CCol>
          </CRow>
        </CCol>
        <div style="clear: both"></div>
        <hr />
        <table class="table table-responsive-sm table-bordered">
          <thead>
            <th>StartDate</th>
            <th>EndDate</th>
            <th>Day</th>
            <th>Start Time</th>
            <th>End Time</th>
          </thead>
          <tbody>
            <tr>
              <td></td>
              <td></td>
              <td></td>
              <td></td>
              <td></td>
            </tr>
          </tbody>
        </table>
      </CCard>
    </div>
  </div>
</template>


<script>
import _ from "lodash";
import Vue from "vue";
Vue.use(require("vue-moment"));
import moment from "moment";
import PulseLoader from "vue-spinner/src/PulseLoader.vue";

import vSelect from "vue-select";
import VuejsDialog from "vuejs-dialog";
import "vuejs-dialog/dist/vuejs-dialog.min.css";
Vue.component("v-select", vSelect);

import "vue-select/dist/vue-select.css";
import "vue-select/src/scss/vue-select.scss";

Vue.use(VuejsDialog);

export default {
  components: {
    PulseLoader,
  },
  data() {
    return {
      subjectsSchedule: {},

      options: [
        {
          Id: 1,
          dayName: "Monday",
        },
        {
          Id: 2,
          dayName: "Tuesday",
        },
        {
          Id: 3,
          dayName: "Wednesday",
        },
        {
          Id: 4,
          dayName: "Thursday",
        },
        {
          Id: 5,
          dayName: "Friday",
        },
        {
          Id: 6,
          dayName: "Saturday",
        },
        {
          Id: 7,
          dayName: "Sunday",
        },
      ],
      StartDate: "",
      EndDate: "",
      selectedDay: "",
      ScheduleTime: "",
      ScheduleTimeEnd: "",
    };
  },
  mounted() {
    this.GetScheduleBySubjectId();
  },
  methods: {
    GetScheduleBySubjectId() {
      this.$API
        .get(
          this.$GetScheduleBySubjectId +
            "?subjectId=" +
            +this.$route.query.subjectId,
          {
            withCredentials: true,
          }
        )
        .then((response) => {
          if (response.status == 200 && response.data != null) {
            this.subjectsSchedule = response.data;
          }
        });
    },
    async CreateSchedule(ID) {
      this.TuitionSubjectId = ID;

      if (
        this.StartDate === "" ||
        this.EndDate === "" ||
        this.selectedDay.dayName === "" ||
        this.StartTime === "" ||
        this.EndTime === ""
      ) {
        this.Error = true;
        this.Message = "Please Complete all the forms";
      } else {
        this.Error = false;
        this.Busy = true;
        const formData = new FormData();

        formData.append("TuitionSubjectId", this.TuitionSubjectId);
        formData.append("StartDate", this.StartDate);
        formData.append("EndDate", this.EndDate);

        formData.append("ScheduleDay", this.selectedDay.dayName);
        formData.append(
          "ScheduleTime",
          moment(this.ScheduleTime).format("hh:mm A")
        );

        formData.append(
          "ScheduleTimeEnd",
          moment(this.ScheduleTimeEnd).format("hh:mm A")
        );

        return this.$API
          .post(this.$InsertNewScheduleBySubId, formData, {
            withCredentials: true,
          })
          .then((response) => {
            if (response.status == 200) {
              this.Busy = false;
              this.$dialog.alert("Success Save Schedule").then(function () {});
              this.FormSchedule = false;
              this.RefreshData();
            } else {
              this.Busy = false;
              this.$dialog.alert("Error to save ").then(function () {});
            }
          })
          .catch((error) => {
            this.Busy = false;
            this.Loading = false;
            this.Error = true;
            this.Message = error.response.data.message;
          });
      }
    },
  },
};
</script>

<style scoped>
.form-group input .form-control {
  display: block;
  width: 100%;
  height: 45px !important;
  padding: 0.375rem 0.75rem;
  font-size: 0.875rem;
  font-weight: 400;
  line-height: 1.5;
  background-clip: padding-box;
  border: 1px solid;
  color: #768192;
  background-color: #fff;
  border-color: #d8dbe0;
  border-radius: 0.25rem;
  -webkit-transition: border-color 0.15s ease-in-out,
    -webkit-box-shadow 0.15s ease-in-out;
  transition: border-color 0.15s ease-in-out,
    -webkit-box-shadow 0.15s ease-in-out;
  transition: border-color 0.15s ease-in-out, box-shadow 0.15s ease-in-out;
  transition: border-color 0.15s ease-in-out, box-shadow 0.15s ease-in-out,
    -webkit-box-shadow 0.15s ease-in-out;
}
</style>

        